import { render } from "./InputNumberField.vue?vue&type=template&id=1a3496c6&scoped=true"
import script from "./InputNumberField.vue?vue&type=script&lang=js"
export * from "./InputNumberField.vue?vue&type=script&lang=js"

import "./InputNumberField.vue?vue&type=style&index=0&id=1a3496c6&scoped=true&lang=scss"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3496c6"]])

export default __exports__